import React from "react";
import "././Faqs.scss";
import { Collapse } from "antd";

const { Panel } = Collapse;

function Faqs() {
	return (
		<div className="faqData" id='faq'>
			<div className="frequentlyAsked container">
				<span className="faqTopText">FAQs</span>
				<h2>Frequently Asked Questions</h2>
				<Collapse bordered={false} defaultActiveKey={["1"]} accordion>
					<Panel
						header={"What is the Universal Wallet Payment System (UWPS)?"}
						key="1"
					>
						<p>
							UWPS is a modern digital payment platform that seamlessly integrates fiat banking, cryptocurrency wallets, and decentralized finance (DeFi) to enable secure, low-cost, fast transactions worldwide.
						</p>
					</Panel>
					<Panel header={"What is UniWallet Pay?"} key="2">
						<p>
							UWPS is a modern digital payment platform that seamlessly integrates fiat banking, cryptocurrency wallets, and decentralized finance (DeFi) to enable secure, low-cost, fast transactions worldwide.
						</p>
					</Panel>
					<Panel
						header={"What is the UWPS Token?"}
						key="3"
					>
						<p>
							UWPS is a modern digital payment platform that seamlessly integrates fiat banking, cryptocurrency wallets, and decentralized finance (DeFi) to enable secure, low-cost, fast transactions worldwide.
						</p>
					</Panel>
					<Panel
						header={"How can I buy UWPS Tokens?"}
						key="4"
					>
						<p>
							UWPS is a modern digital payment platform that seamlessly integrates fiat banking, cryptocurrency wallets, and decentralized finance (DeFi) to enable secure, low-cost, fast transactions worldwide.
						</p>
					</Panel>
					<Panel
						header={"What makes UWPS different from other digital wallets?"}
						key="5"
					>
						<p>
							UWPS is a modern digital payment platform that seamlessly integrates fiat banking, cryptocurrency wallets, and decentralized finance (DeFi) to enable secure, low-cost, fast transactions worldwide.
						</p>
					</Panel>
				</Collapse>
			</div>
		</div>
	);
}

export default Faqs;
